<template>
    <UiCard class="ui-card contact-info" title="Zadzwoń na HelpDesk">
        <div class="phone-wrapper">
            <a-icon icon="Phone" class="text-dark" />
            <span class="text-primary phone-code">+48 </span>
            <span class="text-primary phone-number">
                {{ data.infoline.phone }}
            </span>
        </div>
        <div class="details">
            <div
                class="section"
                v-for="(option, id) in data.infoline.infolineSection"
                :key="id"
            >
                <div class="title text-primary">{{ option.title }}</div>
                <p
                    class="mb-0"
                    v-for="(value, idx) in option.openingHours"
                    :key="idx"
                >
                    {{ value }}
                </p>
            </div>
        </div>
        <div class="divider mt-4 mb-4"></div>
        <div class="mail-wrapper">
            <h6 class="mb-4 title">Napisz wiadomość</h6>
            <div>
                <div
                    class="section"
                    v-for="(option, id) in data.mail"
                    :key="id"
                >
                    <div class="title text-primary">{{ option.title }}</div>
                    <div class="mail">
                        <a-icon icon="Mail" class="text-dark" />
                        <a class="ml-2" :href="`mailto:${option.mail}`">{{
                            option.mail
                        }}</a>
                    </div>
                </div>
            </div>
        </div>
    </UiCard>
</template>

<script>
import { UiCard } from '../../global/ui'
export default {
    name: 'ContactInfo',
    components: { UiCard },
    props: {
        data: {
            type: Object,
            required: true
        }
    }
}
</script>

<style lang="scss">
@import '../../../styles/_custom.scss';
@import '~bootstrap/scss/mixins';
.contact-info {
    .phone-wrapper {
        font-size: 2rem;
        .phone-number {
            font-weight: 400;
        }
        .phone-number {
            font-weight: 600;
        }
    }
    .ui-card-title {
        padding-left: 2rem;
    }
    .details {
        padding-left: 2rem;
        .section {
            margin: 10px 0;
            .title {
                font-weight: 500;
            }
            p {
                font-size: 14px;
            }
        }
    }
    .divider {
        width: 96%;
        margin: 0 auto;
        border-bottom: 1px solid #e0e9ed;
    }
    .mail-wrapper {
        .title {
            padding-left: 2rem;
        }
        .section {
            margin: 10px 0;
            .title {
                font-weight: 500;
            }
            .mail {
                display: flex;
                font-weight: 400;
                a {
                    font-size: 14px;
                    &:not(:hover) {
                        color: #000;
                    }
                }
            }
        }
    }
}
</style>
